import gql from 'graphql-tag';

import { PublicUserFragment } from '../fragments';

export default gql`
  ${PublicUserFragment}

  query interactionsOnContent(
    $contentId: UUID!
    $search: UserContentInteractionSearch
    $pagination: PaginationInput
    $forAdmin: Boolean
  ) {
    interactionsOnContent(
      contentId: $contentId
      search: $search
      pagination: $pagination
      forAdmin: $forAdmin
    ) {
      pageInfo {
        total
        start
        perPage
      }
      items {
        _id
        _created
        _updated
        _createdBy {
          ...PublicUserFragment
        }
        _updatedBy {
          ...PublicUserFragment
        }
        user {
          _id
          name
          profile {
            _id
            name
            email
            image
            logo
          }
        }
        channel {
          _id
        }
        startDate
        endDate
        geo
        data
        state
        features
        actions
        contentData
        version
        status
        lastStatus
      }
    }
  }
`;
